import Home02 from './Home02'
import Home03 from './Home03'
import Home04 from './Home04'
import Home05 from './Home05'
import Home06 from './Home06'
import Home07 from './Home07'
import Home08 from './Home08'
import Explore01 from './Explore01'
import Explore02 from './Explore02'
import Explore03 from './Explore03'
import Explore04 from './Explore04'
import LiveAuctions from './LiveAuctions'
import ItemDetails01 from './ItemDetails01'
import ItemDetails02 from './ItemDetails02'
import Activity01 from './Activity01'
import Activity02 from './Activity02'
import Blog from './Blog'
import BlogDetails from './BlogDetails'
import HelpCenter from './HelpCenter'
import Authors01 from './Authors01'
import Authors02 from './Authors02'
import WalletConnect from './WalletConnect'
import CreateItem from './CreateItem'
import EditProfile from './EditProfile'
import Ranking from './Ranking'

import NoResult from './NoResult'
import FAQ from './FAQ'
import Contact01 from './Contact01'
import Contact02 from './Contact02'

// USER
import Home from './Home'
import Login from './Login'
import SignUp from './SignUp'
import Marketplace from './Marketplace'
import TransactionHistory from './TransactionHistory'
import TransactionDetail from './TransactionDetail'
import Orders from './Orders'
import CreateOrder from './CreateOrder'
import Sell from './Sell'
import CreateSell from './CreateSell'
import Contact from './Contact'
import Collab from './Collab'
import Cart from './Cart'

// ADMIN
import AdminItems from './admin/Items'
import AdminSteamLogs from './admin/SteamLogs'
import AdminOrders from './admin/AdminOrders'
import Transactions from './admin/Transactions'
import Users from './admin/Users'
import Rates from './admin/Rates'

// AUTH
import GuardRoute from '../components/layouts/GuardRoute'

const routes = [
    // USER
    { path: '/', component: <Home /> },
    { path: '/login', component: <Login /> },
    { path: '/sign-up', component: <SignUp /> },
    {
        path: '/edit-profile',
        component: (
            <GuardRoute>
                <EditProfile />
            </GuardRoute>
        ),
    },
    {
        path: '/marketplace',
        component: <Marketplace />,
    },
    {
        path: '/transaction-history',
        component: (
            <GuardRoute>
                <TransactionHistory />
            </GuardRoute>
        ),
    },
    {
        path: '/transaction-detail/:id',
        component: (
            <GuardRoute>
                <TransactionDetail />
            </GuardRoute>
        ),
    },
    {
        path: '/order',
        component: (
            <GuardRoute>
                <Orders />
            </GuardRoute>
        ),
    },
    {
        path: '/create-order',
        component: (
            <GuardRoute>
                <CreateOrder />
            </GuardRoute>
        ),
    },
    {
        path: '/sell',
        component: (
            <GuardRoute>
                <Sell />
            </GuardRoute>
        ),
    },
    {
        path: '/cart',
        component: (
            <GuardRoute>
                <Cart />
            </GuardRoute>
        ),
    },
    {
        path: '/create-sell',
        component: (
            <GuardRoute>
                <CreateSell />
            </GuardRoute>
        ),
    },
    {
        path: '/collab',
        component: <Collab />,
    },
    {
        path: '/contact',
        component: <Contact />,
    },

    // ADMIN
    {
        path: '/admin',
        component: (
            <GuardRoute>
                <Home02 />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/items',
        component: (
            <GuardRoute>
                <AdminItems />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/steam-logs',
        component: (
            <GuardRoute>
                <AdminSteamLogs />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/rates',
        component: (
            <GuardRoute>
                <Rates />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/transactions',
        component: (
            <GuardRoute>
                <Transactions />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/users',
        component: (
            <GuardRoute>
                <Users />
            </GuardRoute>
        ),
    },
    {
        path: '/admin/orders',
        component: (
            <GuardRoute>
                <AdminOrders />
            </GuardRoute>
        ),
    },

    // NO NEEDED
    { path: '/home-02', component: <Home02 /> },
    { path: '/home-03', component: <Home03 /> },
    { path: '/home-04', component: <Home04 /> },
    { path: '/home-05', component: <Home05 /> },
    { path: '/home-06', component: <Home06 /> },
    { path: '/home-07', component: <Home07 /> },
    { path: '/explore-01', component: <Explore01 /> },
    { path: '/explore-02', component: <Explore02 /> },
    { path: '/explore-03', component: <Explore03 /> },
    { path: '/explore-04', component: <Explore04 /> },
    { path: '/live-auctions', component: <LiveAuctions /> },
    { path: '/item-details-01', component: <ItemDetails01 /> },
    { path: '/item-details-02', component: <ItemDetails02 /> },
    { path: '/activity-01', component: <Activity01 /> },
    { path: '/activity-02', component: <Activity02 /> },
    { path: '/blog', component: <Blog /> },
    { path: '/blog-details', component: <BlogDetails /> },
    { path: '/help-center', component: <HelpCenter /> },
    { path: '/authors-01', component: <Authors01 /> },
    { path: '/authors-02', component: <Authors02 /> },
    { path: '/wallet-connect', component: <WalletConnect /> },
    { path: '/create-item', component: <CreateItem /> },
    { path: '/ranking', component: <Ranking /> },
    { path: '/no-result', component: <NoResult /> },
    { path: '/faq', component: <FAQ /> },
    { path: '/contact-01', component: <Contact01 /> },
]

export default routes
